import { render } from "./OrderWidget.vue?vue&type=template&id=1d0c0392&scoped=true"
import script from "./OrderWidget.vue?vue&type=script&lang=js"
export * from "./OrderWidget.vue?vue&type=script&lang=js"

import "./OrderWidget.vue?vue&type=style&index=0&id=1d0c0392&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0c0392"]])

export default __exports__